import React from 'react';
import './index.less';

const TitleHero = ({ heroData }: { heroData: any }) => {
  return (
    <div className="sourcing-and-production-uploader-hero-wrap">
      <div className="title">{heroData?.title}</div>
      <div className="subtitle">{heroData?.subtitle}</div>
    </div>
  );
};
export default TitleHero;
